import React from "react";

const mehmood_deshmukh = () => {
  return (
    <div>
      <h1>Mehmood Deshmukh</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        The criteria was students with <strong>at least 60%</strong> in UG (i.e{" "}
        <strong>6.5 CGPA</strong>) with no backlogs. They also required a
        minimum of <strong>60% in 10th and 12th or diploma.</strong>{" "}
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The <strong>online PPT and aptitude test</strong> was scheduled on{" "}
        <strong>Thursday 24th July</strong>, the <strong>shortlist</strong> was
        announced on <strong>25th July</strong>, and the{" "}
        <strong>interviews</strong> were held on{" "}
        <strong>Monday 28th July.</strong>
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
      </p>

      <p>
        So, the aptitude round had <strong>21 questions</strong> in total.
        Here’s how it went:
      </p>

      <p>
        <strong>Coding Section:</strong>
      </p>

      <ul>
        <li>
          2 coding questions:
          <ol>
            <li>
              One was <strong>Minimum Window Substring</strong> -{" "}
              <a href="https://leetcode.com/problems/minimum-window-substring/description/">
                check it out here
              </a>{" "}
            </li>
            <li>
              The other was a <strong>greedy problem</strong>. I couldn’t find
              it on any coding platform, so here’s a{" "}
              <a href="https://docs.google.com/document/d/1yb-axPnJx1mQJHOG0MOST_wsWKuZfXCjJhx5cAyugTQ/edit?usp=sharing">
                reference doc
              </a>
            </li>
          </ol>
        </li>
      </ul>

      <p>
        <strong>MCQs:</strong>
      </p>

      <ul>
        <li>
          Basics from <strong>Linked Lists, SQL, DBMS</strong>{" "}
        </li>
        <li>
          <strong>OS stuff</strong> like scheduling algorithms, fork-exec{" "}
        </li>
        <li>
          <strong>OOPs</strong> questions - inheritance, virtual
          constructors/destructors
        </li>
      </ul>

      <p>
        Something different with this aptitude test was that there were 3 HR
        questions where you <strong>record yourself while answering</strong>
      </p>

      <p>
        <strong>Note :</strong> Different companies use different platforms for
        the online test, and some have <strong>AI proctoring</strong>. Sometimes
        it gives <strong>false warnings</strong>, so don’t panic, just focus on
        solving (even I got a warning xd! ){" "}
      </p>

      <p>
        Also, don’t freak out if you see OS questions in the aptitude round.
        I’ll tell you how to prep for those in the next part.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />A total of <strong>216 students</strong> were shortlisted for the
        aptitude test. After the round, <strong>25 students</strong> got
        selected, and <strong>3 were waitlisted</strong> ( basically they said
        that “maybe interviewed later” . They were actually interviewed later,
        and one of them got selected :) ), so don’t worry if you end up on the
        waitlist.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The test was held on <strong>Thursday</strong>, and the shortlist came
        out the <strong>next evening</strong>. I was already exhausted from
        another interview that day, so I decided to rest, knowing that I can
        prepare properly over the weekend as the interviews were scheduled on
        Monday.
      </p>

      <p>
        In the early phase of the internship season, you’ll probably face
        multiple aptitude tests and interviews back-to-back. That’s when most
        companies come in clusters, so it can get tiring. Make sure you take
        proper rest in between, it really helps.
      </p>

      <p>
        Over the weekend, I focused on brushing up everything on my resume and
        practicing my communication skills. I had already gone through the TY
        diaries, and they mentioned that <strong>HILTI</strong> usually asks a
        lot of project-based questions (a bit of subtle foreshadowing there xd
        ). So, I made sure I knew every detail of my projects inside out.
      </p>

      <p>
        I also prepared for some common HR questions like:{" "}
        <strong>
          Introduction, Why do you want to join us? Why CS and why COEP? Future
          goals and where do you see yourself in 5 years? What are 3 things that
          would make you stay longer with a company?
        </strong>
      </p>

      <p>
        It’s always good to be ready for these types of questions; they really
        boost your confidence during the interview and it definitely helped me
        during the HR round.
      </p>

      <p>
        As for DSA, I didn’t spend time on it, I was confident enough in the
        prep I’d done over the summer.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were two rounds in the interview, one <strong>
          technical
        </strong>{" "}
        and one <strong>HR</strong>. It’s important to know that there are
        multiple panels for the technical round, and each panel can be quite
        different in the kind of questions they ask.
      </p>

      <p>
        My technical interview started with a short introduction about myself. I
        was a bit nervous at first, but I got comfortable once I realized the
        interviewer liked my introduction. <strong>A good tip here:</strong>{" "}
        include a few topics in your intro that you’re confident about and that
        can make the interviewer curious. I mentioned how I enjoy participating
        in hackathons and how I love making and breaking stuff (projects). It
        worked, the interviewer immediately asked me about hackathons.
      </p>

      <p>
        He asked for my resume, and then jumped straight into questions about my
        projects - COEP’s PhD admission portal, my garbage collector, and the
        BitTorrent client. To give you a better idea of what type of questions
        to expect, here are some of the questions and what I answered:
      </p>

      <p>
        <strong>PhD Admission Portal:</strong>
      </p>

      <p>
        <strong>What is the entire structure of the portal?</strong> - here i
        explained with a short intro of the project, then explained the roles
        and the entire flow of the portal
      </p>

      <p>
        <strong>
          <em>What tech stack did you use for the PhD portal?</em>
        </strong>{" "}
        - I used the MERN stack.
        <br />
        <em>
          Why NoSQL and not SQL? - here it’s important to give a justifiable
          answer, like the answer I gave was for PhD admissions, the applicant
          schema is not fixed or rigid, taking into consideration that different
          types of candidates require different fields and documents.
          Considering that we needed a very flexible schema. Also the amount of
          time we were given was bit short and so we went with mongoDB as we
          were already familiar with it.
        </em>
      </p>

      <p>
        <em>
          What were the problems with the old portal (since I mentioned that I
          redeveloped it)? - i explained the problems we faced while maintaining
          the old portal and how the new portal solves them.
        </em>
      </p>

      <p>
        <strong>Garbage Collector:</strong>
      </p>

      <p>
        <em>Explain the process of garbage collection.</em>
        <br />
        <em>Describe the various algorithms and compare them.</em>
        <br />
        <em>Compare it with the garbage collection process in Java.</em>
      </p>

      <p>
        <strong>BitTorrent Client:</strong>
      </p>

      <p>
        <em>Explain the BitTorrent protocol.</em>
      </p>

      <p>
        <em>
          Compare peer-to-peer architecture with client-server architecture.
        </em>
      </p>

      <p>
        After the projects, I was asked the toughest DSA question…….
        <em>“Reverse a Linked List.”</em> No really, i was asked this :)
      </p>

      <p>
        I knew the optimal solution, but I still explained first the{" "}
        <strong>brute &amp; better</strong> solutions, and then the{" "}
        <strong>optimal approach</strong>, just like (my goat){" "}
        <strong>Striver</strong> teaches. While solving, it’s really important
        to think out loud. The interviewer doesn’t expect you to instantly give
        the perfect solution; they want to see how you think and approach the
        problem.
      </p>

      <p>
        After I explained all three approaches, he asked me to dry run the
        optimal one with an example.
      </p>

      <p>
        Next, I was given a puzzle:{" "}
        <strong>
          Measure 45 minutes using two identical ropes that burn non-uniformly.
        </strong>{" "}
        (You can find the same one here:{" "}
        <a href="https://www.geeksforgeeks.org/aptitude/puzzle-1-how-to-measure-45-minutes-using-two-identical-wires/">
          GeeksforGeeks puzzle
        </a>{" "}
        )
      </p>

      <p>
        I had already read a few common puzzles like this, so I was able to
        solve it quite easily.
      </p>

      <p>
        Finally, I was asked another problem:{" "}
        <em>check whether a word is a palindrome or not.</em> I explained the
        logic clearly, and the interviewer seemed happy with my answer.
      </p>

      <p>
        Before wrapping up, he asked if I had made any project that my
        classmates had actually used. I mentioned a project I made in my SY, and
        he even looked up its GitHub repository right there.
      </p>

      <p>
        In the end, he asked if I had any questions for him. I asked why HILTI
        doesn’t use cross-platform technologies instead of native ones, and we
        had a short but interesting discussion about that.
      </p>

      <p>
        The interview lasted around an hour and ended on a really good note.
      </p>

      <p>
        <strong>The HR round:</strong>{" "}
      </p>

      <p>
        The HR round began with a short introduction about myself, and the first
        question he asked was where I was from. Luckily, he had visited my
        hometown before, so he could relate to what I said, which helped set a
        comfortable tone for the discussion.
      </p>

      <p>
        He then moved to my resume and asked a few general questions about my
        projects. Since this was the HR round, I made sure not to use technical
        jargon and explained everything in simple, layman terms.
      </p>

      <p>After that, he asked the typical HR questions such as:</p>

      <p>
        <em>Why do you want to join HILTI?</em>
      </p>

      <p>
        <em>Where do you see yourself in 5 years?</em>
      </p>

      <p>
        <em>What do you know about HILTI?</em>
      </p>

      <p>
        The best way to answer these, in my opinion, is to attend the company’s
        PPT beforehand and refer to points mentioned there. It really helps you
        give relevant and genuine answers.
      </p>

      <p>Then I was asked about my Extracurricular activities in my resume.</p>

      <p>
        He also asked if I knew about HILTI before the internship cycle.
        Fortunately, I had watched <em>Money Heist</em> last December, and HILTI
        had sponsored the show. When I brought that up, we ended up having a fun
        little discussion about favourite characters, which season was the best,
        and so on.
      </p>

      <p>
        Towards the end, he asked a few questions about time management, and
        that wrapped up the session.
      </p>

      <p>The entire HR round lasted for around 30 minutes.</p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />I think I have mentioned them in the previous question. Some
        topics on which I was asked in the DE SHAW interview are -{" "}
      </p>

      <ul>
        <li>
          <p>
            <strong>DSA:</strong> A graph problem based on articulation points
            (similar to{" "}
            <a href="https://leetcode.com/problems/critical-connections-in-a-network/description/">
              <em>Critical Connections in a Network</em>
            </a>
            )
          </p>
        </li>
        <li>
          <p>
            <strong>DBMS:</strong> SQL queries
          </p>
        </li>
        <li>
          <p>
            <strong>Networks:</strong> Differences between TCP and UDP,
            peer-to-peer and client-server architecture
          </p>
        </li>
        <li>
          <p>
            <strong>System Design:</strong> Design a rate limiter
          </p>
        </li>
        <li>
          <p>
            <strong>OOP:</strong> Four pillars of object-oriented programming
          </p>
        </li>
      </ul>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        So there are multiple sources which I followed but these are the ones
        which I think will be the best when it comes to Internship preparation.
      </p>

      <p>
        <strong>For DSA : Striver’s A2Z DSA sheet and the YT playlist -</strong>{" "}
        <a href="https://takeuforward.org/strivers-a2z-dsa-course/strivers-a2z-dsa-course-sheet-2">
          Link
        </a>
        <br />
        I would say that this is the best resource for DSA, not only the
        questions are well organised but the video solutions are to the point.
        <br />
        The approach I would recommend would be to spend some time trying to
        solve the question on your own. Even a brute force solution is okay at
        the beginning but then its time to brainstorm for a better solution and
        when you feel you won’t be able to solve further then go ahead with the
        video solution.
        <br />
        Also, even if you are able to solve the question, make sure to watch the
        video as Striver tries to build your intuition towards the optimal
        solution by going from the <strong>Brute</strong> to{" "}
        <strong>Better</strong> to <strong>Optimal</strong> solution.
      </p>

      <p>
        <strong>For DBMS:</strong>
        <br />I referred the book <em>Database system concepts</em> for DBMS and
        SQL, but I found it overkill. -{" "}
        <a href="https://people.vts.su.ac.rs/~peti/Baze%20podataka/Literatura/Silberschatz-Database%20System%20Concepts%206th%20ed.pdf">
          Link
        </a>
        <br />
        For DBMS you could go with{" "}
        <strong>
          <em>Gate Smashers</em>
        </strong>{" "}
        playlist. -{" "}
        <a href="https://www.youtube.com/playlist?list=PLxCzCOWd7aiFAN6I8CuViBuCdJgiOkT2Y">
          Link
        </a>
        <br />
        And for SQL you can refer geeksforgeeks and practice on{" "}
        <strong>Leetcode SQL 50 -</strong>{" "}
        <a href="https://leetcode.com/studyplan/top-sql-50/">Link</a>
      </p>

      <p>
        <strong>For CN:</strong>
        <br />
        You can refer Abhijit sir’s lectures available on Youtube and also the
        book <em>Computer Network : A top down Approach</em> -{" "}
        <a href="https://www.youtube.com/playlist?list=PLI6tb_y9bRBSM6Wj-nX1upE3jnHfzN8ll">
          Link
        </a>
        <br />
        The videos should be sufficient but if you want to study in detail (not
        expected for interview you can read the book
      </p>

      <p>
        <strong>For aptitude rounds:</strong>
        <br />
        You can refer Indiabix for this -{" "}
        <a href="https://www.indiabix.com/">Link</a>{" "}
      </p>

      <p>
        <strong>For puzzles that are generally asked in Interviews -</strong>{" "}
        <a href="https://www.geeksforgeeks.org/aptitude/top-100-puzzles-asked-in-interviews/">
          Link
        </a>
      </p>

      <p>
        I wouldn’t suggest preparing OS for internship interviews because it is
        something that is not expected. (even if you are asked a question
        related to OS you can simply say that you haven’t studied the topic yet)
        <br />
        But still if you want to learn OS you can refer Abhijit sir’s videos on
        YT -{" "}
        <a href="https://www.youtube.com/playlist?list=PLI6tb_y9bRBStTZvyQVbzV9o6890HXecS">
          Link
        </a>
      </p>

      <p>
        <strong>
          For CORE subjects please prepare the commonly asked interview
          questions from GFG and interviewbit. !!
        </strong>{" "}
        - this is very important as most of the questions asked are very common
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        So the approach for solving Coding questions is very simple.
      </p>

      <ul>
        <li>Make sure to read the example completely </li>
        <li>Take a look at the examples given </li>
        <li>Start with a brute force solution </li>
        <li>
          Looking at the brute force solution think of the Data Structures or
          Algorithms you can use to improve the solution{" "}
        </li>
        <li>Always dry run </li>
      </ul>

      <p>
        During interviews make sure to read aloud whatever you are thinking. The
        interviewers want to know your thought process while approaching the
        problem.
        <br />
        If you think you are stuck you can ask them for some hints.
      </p>

      <p>
        <strong>Now during the preparation follow these:</strong>
      </p>

      <ol>
        <li>
          <strong>Be consistent</strong>: Solve 2-3 problems daily and please
          don’t solve more than 5 a day. Solve a few problems but make sure you
          are thorough with the solution and concept used in it.{" "}
        </li>
        <li>
          <strong>Write good and clean code</strong>: use better naming
          conventions instead of using the common variable names like n, i , j{" "}
        </li>
        <li>
          <strong>Write your solutions</strong>: you can use a book or an
          editor, but make sure to write the approach used. This will help you
          when you want to revise a concept{" "}
        </li>
        <li>
          <strong>Have a habit to dry run your solutions:</strong> This is a
          good practice which improves your understanding how the data
          structures or algorithms work
        </li>
      </ol>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Yes, there were questions asked about projects, clubs and
        extracurricular activities.
        <br />
        The <strong>technical rounds</strong> involved a lot of questions around
        the projects, so make sure you are{" "}
        <strong>well-versed with your projects.</strong>
        <br />
        Because I got one of my projects (the PhD portal) from{" "}
        <strong>SDS</strong>, there were few questions about it like{" "}
        <strong>what is SDS</strong>,{" "}
        <strong>
          what are some other projects and activities undertaken by SDS.
        </strong>
        <br />I was also asked about <strong>MindSpark</strong> and my
        responsibility as the Web and App head. (it’s a coincidence that there
        were already two web and app heads from Mindspark at HILTI :) I did
        mention this point as fun during the HR round)
        <br />
        Related to extracurricular activities I was asked about sketching which
        I mentioned in my resume.
      </p>

      <p>
        I was also asked about the awards and prizes like hackathon wins, alumni
        association prize etc
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?
      </p>

      <p>For HILTI there are two very important things that matter: </p>

      <ol>
        <li>Good projects </li>
        <li>Good communication</li>
      </ol>

      <p>
        I think I have already given enough emphasis on projects. For the
        communication part, you should work on your soft skills, body language
        etc
        <br />
        Also make sure you go through the company’s PPT and include the points
        mentioned in it during the HR round ( so make sure you take photos of
        the ppt). Being familiar with the company, its goals, principles equips
        you with good answers to HR questions like{" "}
        <strong>
          what do you know about us, why do you wanna join us etc.
        </strong>
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        The first tip I would like to give is{" "}
        <strong>start your prep early!!!</strong> If you have just finished your
        SEM-3 , now is the time to start your preparations.{" "}
      </p>

      <p>
        Make sure to make <strong>good meaningful projects</strong>. Try to
        build something which will make the interviewer curious to know about
        it. Also make sure you have actually worked on it and are familiar with
        every part (<strong>no vibecoding :)</strong> )<br />
        This will help you answer the technical questions about your projects.
      </p>

      <p>
        Your <strong>resume</strong> is the most important thing. It will be
        your <strong>question bank</strong> during the interview so make sure
        you are familiar with every single word you mention in it.
        <br />
        Make sure it is not filled with text, keep it short, simple and sweet.
      </p>

      <p>
        Avoid mentioning topics which you don’t know and keep the{" "}
        <strong>descriptions of your projects short.</strong> This should make
        the interviewer curious to know more about the project.
      </p>

      <p>
        Focus on your communication skills, practice answering the common HR
        questions with someone or maybe in front of a mirror. Keep your answers
        precise and avoid talking too much on a single question.
      </p>

      <p>
        For CORE subjects, make sure to prepare the commonly asked questions.
      </p>

      <p>
        <strong>Now the most important tip:</strong>
        <br />
        This entire process of internships can be tiring, it will make you
        anxious. Sometimes you will be scared before the aptitude rounds or
        interviews.
        <br />
        So just know that this happens with everyone. Keep talking with your
        friends, family, make sure to take enough rest!! Have faith in your own
        efforts and you’ll be golden.
      </p>

      <p>
        Even if you are not selected, its an opportunity to learn, talk with
        interviewer asking him about areas to improve (I did it myself and it
        was really helpful)
      </p>

      <p>
        You will be nervous during the interviews but it will take you just a
        few minutes to get comfortable!
      </p>

      <p>ALL THE BEST!!!</p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong> <a href="mailto:deshmukhmr23.comp@coeptech.ac.in">deshmukhmr23.comp@coeptech.ac.in</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/mehmood-deshmukh-93533a2a7/">
          Mehmood Deshmukh
        </a>
      </p>
    </div>
  );
};

export default mehmood_deshmukh;
